import { FC, useState } from 'react';
import { Tooltip } from '@mui/material';
import SearchClientModal from 'src/pages/Client/Modal/Search';
import UpdateClientModal from 'src/pages/Client/Modal/Update';
import AddClientModal from 'src/pages/Client/Modal/Add';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { BadgeThemeOrderEnum } from 'src/models/IOrder';
import { IClientFetch } from 'src/models/IClient';
import Icons from 'src/common/icons';

interface IProps {
  id: number;
  client: IClientFetch;
  status: keyof typeof BadgeThemeOrderEnum;
}

const CustomerDataActions: FC<IProps> = ({ id, client, status }) => {
  const { role } = useTypedSelector(state => state.auth);
  const [open, setOpen] = useState(false);
  const [openEdit, setEditOpen] = useState(false);
  const [openSearch, setSearchOpen] = useState(false);

  const handleOpen = (name: string) => {
    switch (name) {
      case 'add':
        setOpen(true);
        break;
      case 'edit':
        setEditOpen(true);
        break;
      case 'search':
        setSearchOpen(true);
        break;
      default:
        break;
    }
  };

  const handleClose = (name: string) => {
    switch (name) {
      case 'add':
        return setOpen(false);
      case 'edit':
        return setEditOpen(false);
      case 'search':
        return setSearchOpen(false);
      default:
        break;
    }
  };

  return (
    <>
      {status === 'blocked' && role !== 'admin' ? (
        <></>
      ) : (
        <>
          <Tooltip title='Change client'>
            <div
              onClick={() => handleOpen('add')}
              className='order-show__title__action add icon_stroke'
            >
              <Icons.Plus />
            </div>
          </Tooltip>
          <Tooltip title='Search client'>
            <div
              onClick={() => handleOpen('search')}
              className='order-show__title__action find icon_stroke'
            >
              <Icons.Search />
            </div>
          </Tooltip>
          <Tooltip title='Edit client'>
            <div
              onClick={() => handleOpen('edit')}
              className='order-show__title__action icon_stroke'
            >
              <Icons.Edit />
            </div>
          </Tooltip>
        </>
      )}
      <AddClientModal open={open} handleClose={() => handleClose('add')} orderId={id} />
      <UpdateClientModal open={openEdit} handleClose={() => handleClose('edit')} client={client} />
      <SearchClientModal open={openSearch} handleClose={() => handleClose('search')} orderId={id} />
    </>
  );
};

export default CustomerDataActions;
